export default "__VITE_ASSET__CHjfRwJq__"